const dateRange = (date1, date2) => {
  const d1 = new Date(date1.year, date1.month, date1.day);
  const d2 = new Date(date2.year, date2.month, date2.day);
  return d1 > d2 ? {
    start_date: date2,
    end_date: date1
  } : {
    start_date: date1,
    end_date: date2
  };
};

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


export default dateRange;

export { months };
